import { render, staticRenderFns } from "./AxisList.vue?vue&type=template&id=57f0a36c&scoped=true"
import script from "./AxisList.vue?vue&type=script&lang=js"
export * from "./AxisList.vue?vue&type=script&lang=js"
import style0 from "./AxisList.vue?vue&type=style&index=0&id=57f0a36c&prod&lang=less&scoped=true"
import style1 from "./AxisList.vue?vue&type=style&index=1&id=57f0a36c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f0a36c",
  null
  
)

export default component.exports